import React, { useState } from "react";
import cn from "classnames";
import styles from "./Condition.module.sass";
import Item from "../Item";
import Switch from "../../../components/Switch";

const Conditions = ({ className }) => {
  const [isAccepted, setIsAccepted] = useState(false);

  const handleAcceptChange = () => {
    setIsAccepted(!isAccepted);
  };


  return (
    <Item
      className={cn(styles.card, className)}
      title="Récapitulatif & envoi"
      classTitle="title-purple"
    >
      <div className={styles.fieldset}>
        <div className={styles.conditions}>
          <h3>J'atteste :</h3>
          <ul className={styles.attestationList}>
            <li>de l'exactitude des informations mentionnées dans la précédente demande</li>
            <li>que les informations saisies dans le formulaire sont conformes aux informations du contrat conclu avec l'apprenti(e)</li>
            <li>que le Cerfa est visé par l'organisme de formation en apprentissage</li>
            <li>que le Cerfa est signé par les parties (employeur, apprenti(e) et à son représentant légal le cas échéant) et m'engage :</li>
            <li>à tenir les pièces justificatives à disposition des services de contrôle (OPCO, administration)</li>
            <li>avoir pris connaissance et accepte les conditions générales en vigueur.</li>
          </ul>
        </div>
        
        <div className={styles.acceptContainer}>
          <div className={styles.line}>
            <div className={styles.title}>
              J'accepte les conditions et je certifie l'exactitude des informations
            </div>
            <Switch
              className={styles.switch}
              value={isAccepted}
              onChange={handleAcceptChange}
            />
          </div>
        </div>
        
      </div>
    </Item>
  );
};

export default Conditions;